import Button from "components/Button";
import Loader from "components/Loader";
import Text from "components/Text";
import { UserResponse } from "pages/Profile/EditProfile/PersonalDetails/types";
import { CustomUrlButtonSection, CustomUrlSection, FlexContainer, LeftSection, ProfileInnerWrapper, ProfileWrapper, ResourcesItem, ResourcesList, ResourcesSection, RightSection } from "pages/Profile/Profile.styled";
import { FC, useEffect, useState } from "react";
import { TbFileText } from "react-icons/tb";
import { useLocation, useParams } from "react-router-dom";
import { useGetAgencyQuery, useGetUserQuery } from "slice/user";
import theme from "theme";
import "./agency.css";
import CompanyCard from "./components/CompanyCard";
import {
    AdressProps,
    SocialHandlesProps,
} from "./components/ContactCard";
import { InfoTabs } from "./components/InfoTabs/InfoTabs";

export const AgencyInformation: FC = () => {
    const {pathname} = useLocation()
    const {id: agency_id} = useParams()
    const [data, setData] = useState<UserResponse>()
    const {data: userData, isLoading, refetch } = useGetUserQuery("1 ", {
        skip: agency_id ? true : false,
    });
    const { data: agencyData, isLoading: isAgencyLoading, refetch: refetchAgency } = useGetAgencyQuery(agency_id as string, {
        skip: agency_id ? false : true,
    });

    useEffect(() => {
        if(agency_id){
            refetchAgency()
        }else{
      refetch();
        }
    }, [pathname, agency_id])

    useEffect(() => {
        if(agency_id){
            setData(agencyData)
        }else{
            setData(userData)
        }
      }, [agencyData, userData, agency_id])

    const [addressInfo, setAddressInfo] = useState<AdressProps>({
        zip: "",
        city: "",
        state: "",
        address: "",
        country: "",
    });

    const [socialHandles, setSocialHandles] = useState<SocialHandlesProps>(Array<{
        id: string;
        username: string;
        user_id: string;
        created_at: string;
        updated_at: string;
        social_platforms_id: number;
    }>);

    useEffect(() => {
        if (data?.data?.attributes?.agency?.address) {
            const agencyAddress = data.data.attributes.agency.address;
            setAddressInfo({
                zip: agencyAddress.zip,
                city: agencyAddress.city,
                state: agencyAddress.state,
                address: agencyAddress.address,
                country: agencyAddress.country
            });
        }
        if (data?.data?.attributes) {
            const socialLinks = [ ...data.data.attributes.social_links ];
            setSocialHandles(socialLinks);
        }
    }, [data]);

    
    // return (
    //     <div>
    //         <div
    //             style={{
    //                 display: "flex",
    //                 gap: "2rem",
    //                 flexDirection: "column",
    //                 paddingTop: "12vh",
    //             }}
    //         >
    //             <div style={{ display: "flex", gap: "2rem" }}>
    //                 <CompanyCard />
    //                 <ContactCard
    //                     zip={addressInfo.zip}
    //                     city={addressInfo.city}
    //                     state={addressInfo.state}
    //                     address={addressInfo.address}
    //                     country={addressInfo.country}
    //                     socialHandles={socialHandles}
    //                 />
    //             </div>
    //             <CurrentOpenings />
    //         </div>
    //     </div>
    // );
 
    if (isLoading || isAgencyLoading) {
        return (
            <ProfileWrapper>
                <Loader size={28} />
            </ProfileWrapper>
        );
    }

    return (
        <ProfileWrapper>
            <ProfileInnerWrapper>
                <Text variant="heading5" fontWeight="700">
                    {agency_id ? "Agency Profile" : "My Profile"}
                </Text>
                <FlexContainer>
                    <LeftSection>
                        <CompanyCard socialHandles={socialHandles} data={data} />
                        <InfoTabs addressInfo={addressInfo} />
                    </LeftSection>
                    <RightSection>
                        <CustomUrlSection>
                            <Text variant="body2" fontWeight="600" color="#fff">
                                Want a custom URL for your profile?
                            </Text>
                            <Text variant="label" color="#8a8a8a">
                                Eveniet porro non aut exercitationem aspernatur
                                porro blanditiis consequatur dignissimos.
                            </Text>
                            <CustomUrlButtonSection>
                                <Button
                                    type="button"
                                    variant="filled"
                                    fullWidth
                                >
                                    Upgrade Now
                                </Button>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    fullWidth
                                >
                                    Edit Now
                                </Button>
                            </CustomUrlButtonSection>
                        </CustomUrlSection>
                        <ResourcesSection>
                            <Text variant="label">Resources</Text>
                            <Text
                                variant="label"
                                color={theme.colors.grey.secondary}
                            >
                                Tips on building a professional model profile
                                that will help you get noticed.
                            </Text>
                            <ResourcesList>
                                <ResourcesItem>
                                    <TbFileText fontSize="20px" />
                                    <Text variant="label">
                                        tempore voluptas ducimus plac eat. Sit
                                        eos
                                    </Text>
                                </ResourcesItem>
                                <ResourcesItem>
                                    <TbFileText fontSize="20px" />
                                    <Text variant="label">
                                        tempore voluptas ducimus plac eat. Sit
                                        eos
                                    </Text>
                                </ResourcesItem>
                                <ResourcesItem>
                                    <TbFileText fontSize="20px" />
                                    <Text variant="label">
                                        tempore voluptas ducimus plac eat. Sit
                                        eos
                                    </Text>
                                </ResourcesItem>
                            </ResourcesList>
                        </ResourcesSection>
                    </RightSection>
                </FlexContainer>
            </ProfileInnerWrapper>
        </ProfileWrapper>
    );
};
